<template>
  <div class="packageDesc">
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">购买详情</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 购买服务顶部 开始 -->
    <div class="packageDesc_top">
      <img class="packageDesc_img" :src=" showItem.product && showItem.product.thumb " />
      <div class="packageDesc_name">{{ showItem.name }}</div>
    </div>
    <!-- 购买服务顶部 结束 -->
    <!-- 商品信息 开始 -->
    <div class="packageDesc_shangpinmesg">
      <div class="packageDesc_shangpin_title">
        <img class="packageDesc_shangpin_title_icon" src="/static/newprojecticon/title.png" />
        <div class="packageDesc_shangpin_title_name">商品信息</div>
      </div>
      <div class="packageDesc_shangpin_box">
        <div class="packageDesc_shangpin_mesgname">原价</div>
        <div class="packageDesc_shangpin_mesgvalue">￥{{ showItem.m_price }}</div>
      </div>
      <div class="packageDesc_shangpin_box">
        <div class="packageDesc_shangpin_mesgname">售价</div>
        <div class="packageDesc_shangpin_shoujia">￥{{ showItem.price }}</div>
      </div>
      <!-- <div class="packageDesc_shangpin_box">
        <div class="packageDesc_shangpin_mesgname">套餐</div>
        <div class="packageDesc_taocanbox">
          <div v-for="(item,index)  in showItem.productItem" :key="index" :class="packageIndex===index ? 'packageDesc_shangpin_taocan' : 'packageDesc_shangpin_taocan1' "
            @click="changePackage(index)" id="changePackage" :data-index=" index ">{{item.name}}</div>
        </div>
      </div>
      <div class="packageDesc_shangpin_box" @click="toServiceList(showItem.id)" id="toServiceList" :data-service_id="showItem.id">
        <div class="packageDesc_shangpin_mesgname">适用网点</div>
        <div class="packageDesc_shangpin_shoujia">点击查看服务网点</div>
      </div> -->
      <div class="packageDesc_shangpin_box">
        <div class="packageDesc_shangpin_mesgname">可用时段</div>
        <div class="packageDesc_shangpin_usetime">周一至周日（法定节日除外）</div>
      </div>
    </div>
    <!-- 商品信息 结束 -->
    <!-- 支付 开始 -->
    <!-- <div class="page_button packageDesc_button" @click="toBuy()">
      <div class="page_zhifu">立即购买</div>
    </div> -->
    <div class="packageDesc_button">
      <div class="page_zhifu" @click="toBuySend()">赠送好友</div>
      <div class="page_zhifu1" @click="toBuy()">立即购买</div>
    </div>
    <!-- 支付 结束 -->
    <!-- 注意事项 开始 -->
    <div class="page_mesg">
      <div class="page_mesgtitle">
        <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
        <div class="page_mesgtext">注意事项</div>
      </div>
      <div class="page_mesgtip">此商品为电子券，购买后可在“<span class="page_mesgtipspan">个人中心-卡券</span>”页面查询使用;</div>
      <div class="page_mesgtip">洗车打蜡券使用说明：网点使用服务后出示券二维码，商家扫描即可;</div>
      <div class="page_mesgtip">机油服务使用说明：机油服务所使用机油产品由“优越服务”官方提供，商家提供安装服务，使用服务前需提前预约；</div>
      <div class="page_mesgtip">漆面修复使用说明：单独喷漆服务（珍珠漆除外），不含钣金及拆装费，网点使用服务后出示券二维码，商家扫描即可；</div>
      <div class="page_mesgtip">服务券有效期为一年，逾期失效，购买后非特殊原因不能退款;</div>
      <div class="page_mesgtip">优惠活动由“优越服务”平台策划，商家提供服务，部分套餐限量供应，售完即止。</div>
    </div>
    <!-- 注意事项 结束 -->
    <!-- 弹框 -->
    <van-dialog v-model="show" title="赠送好友" show-cancel-button :beforeClose="chargeBtn">
      <!--输入框-->
      <van-field v-model="phoneNum" rows="1" autosize  type="number" placeholder="请输入手机号" style="text-align: center;font-size: 14px;" />
    </van-dialog>
  </div>
</template>

<script>
  import httper from '../../api/http';

  export default {
    data() {
      return {
        id: '', // 上一页获取套餐详情编号,默认为空
        showItem: {}, // 接口获取套餐详情,默认为空
        packageIndex: 0, // 上一页获取套餐详情的套餐列表的指针,默认为0
        userInfo: {}, //接口获取用户信息
        mobile: "",
        phoneNum: "",
        show: false
      }
    },
    created() {
      let that = this
      //上一页面传过来的参数
      console.log("id", that.$route.query.id)
      if (that.$route.query.id) {
        that.id = Number(that.$route.query.id)
      } else {
        that.id = ""
      }
      // console.log("packageIndex", that.$route.query.index)
      if (that.$route.query.index) {
        that.packageIndex = Number(that.$route.query.index)
      } else {
        that.packageIndex = 0
      }

      this.request("getUserInfo")
    },
    mounted() {
      if (!this.id) return
      let requestData = {
        id: this.id
      }
      this.request('getPackageDetail', requestData)

    },
    methods: {
      pageReturn(){
        this.$router.go(-1)
      },
      pageToIndex(){
        this.$router.push({
          path:"/"
        })
      },
      toBuySend() {
        //当点击按钮时，显示弹出框
        this.show = true;
      },
      chargeBtn(action, done) { //确认or取消
        if (action === 'cancel') { //取消按钮
          done();
        } else if (action === 'confirm') { //确定按钮
          //向后端传值并关闭dialog弹出框
          this.show = false;
          let showItem = this.showItem
          if (!(/^1[3456789]\d{9}$/.test(Number(this.phoneNum)))) {
            this.$toast({
              message: '手机号格式错误'
            })
            done();
            return
          }
          this.$router.push({
            path: '/buy',
            query: {
              showItem: showItem,
              phoneNum: this.phoneNum
            }
          })
        };
        // this.message='';
        done();
      },
      // 点击触发
      // 切换商品的套餐
      changePackage(index) {
        this.showItem.productItem.map((item, index) => item.checked = index === Number(index))
        this.showItem = this.showItem
        this.packageIndex = Number(index)
      },
      // 跳转到服务商家页面
      toServiceList(product_id) {
        this.$router.push({
          path: '/serviceList',
          query: {
            product_id: product_id
          }
        })
      },
      // 带参跳转到订单支付页面
      toBuy() {
        console.log((!this.mobile))
        if ((!this.mobile)) {
          this.$toast({
            message: '请先绑定手机',
          }).then((confirm) => {
            if (confirm) {
              this.$router.push({
                path: '/changePhoneNum'
                // url: '../welcome/welcome?phoneStatus=true'
              })
            } else {
              return false;
            }
          })
        }
        // let id = this.packageIndex
        // let item = this.showItem.productItem[id]
        // let originalPrice = item.m_price ? parseFloat(item.m_price).toFixed(2) : '0.00'
        // let price = item.price ? parseFloat(item.price).toFixed(2) : '0.00'
        // let thumb = this.showItem.thumb
        let showItem = this.showItem
        this.$router.push({
          path: '/buy',
          // query: {
          //   item_id: item.id,
          //   name: item.name,
          //   originalPrice: originalPrice,
          //   price: price,
          //   thumb:thumb
          // }
          query: {
            showItem: showItem,
          }
        })
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //获取用户信息
          case 'getUserInfo':
            httper.get('wechat/user/info', requestData, res => {
              if (res.code == 0) {
                console.log("用户信息", res.data)
                that.userInfo = res.data
                that.mobile = res.data.mobile
              }
            }, true)
            break
            //  获取套餐详情
          // case 'getPackageDetail':
          //   httper.get('product/detail', requestData, res => {
          //     console.log('套餐详情', res)
          //     that.showItem = res.data
          //     res.data.productItem.map((item, index) => item.checked = index === that.packageIndex)
          //     that.showItem = res.data
          //   }, false)
          //   break
            case 'getPackageDetail':
              httper.get('/store/service-detail', requestData, res => {
                console.log('套餐详情', res)
                that.showItem = res.data
                // res.data.productItem.map((item, index) => item.checked = index === that.packageIndex)
                // that.showItem = res.data
              }, false)
              break
        }
      }
    }
  }
</script>

<style scoped>
  .packageDesc {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .packageDesc_top {
    margin: 10px 0;
    width: 90%;
    height: 134px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 4px 1px rgba(187, 187, 187, 0.3);
    border-radius: 7px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .packageDesc_img {
    width: 35px;
    height: 35px;
    margin-bottom: 10px;
  }

  .packageDesc_name {
    font-size: 19px;
    font-weight: bold;
    color: rgba(53, 53, 53, 1);
  }

  .packageDesc_shangpin_title {
    display: flex;
    align-items: center;
  }

  .packageDesc_shangpin_title_icon {
    width: 3px;
    height: 23px;
    margin-right: 10px;
  }

  .packageDesc_shangpin_title_name {
    font-size: 15px;
    font-weight: 400;
    color: rgba(53, 53, 53, 1);
  }

  .packageDesc_shangpinmesg {
    width: 90%;
    /* height: 268px; */
    height: 170px;
    padding: 10px;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 4px 1px rgba(187, 187, 187, 0.3);
    border-radius: 7px;
  }

  .packageDesc_shangpin_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
  }

  .packageDesc_shangpin_mesgname {
    font-size: 11px;
    font-weight: 400;
    color: rgba(101, 101, 101, 1);
  }

  .packageDesc_shangpin_mesgvalue {
    text-decoration: line-through;
    font-size: 11px;
    font-weight: 400;
    color: rgba(187, 187, 187, 1);
  }

  .packageDesc_shangpin_shoujia {
    font-size: 11px;
    font-weight: 400;
    color: #FD8C00;
  }

  .packageDesc_taocanbox {
    display: flex;
    justify-content: end;
    align-items: center;

  }

  .packageDesc_shangpin_taocan {
    width: 69px;
    height: 23px;
    background: #FD8C00;
    border: 1px solid #FD8C00;
    border-radius: 11px;
    font-size: 11px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    margin-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .packageDesc_shangpin_taocan1 {
    width: 69px;
    height: 23px;
    border: 1px solid #FD8C00;
    border-radius: 11px;
    font-size: 11px;
    font-weight: 400;
    color: #FD8C00;
    margin-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .packageDesc_shangpin_usetime {
    font-size: 11px;
    font-weight: 400;
    color: rgba(53, 53, 53, 1);
  }
  .packageDesc_button{
    /* margin-top: 20px; */
    margin: 150px 30px 0 30px;
    margin-top: 20px;
    width: 100%;
    height: 46px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #fff;
  }
  .page_zhifu {
    width: 176px;
    height: 46px;
    background: linear-gradient(90deg, rgba(252, 183, 51, 1) 0%, rgba(242, 211, 86, 1) 100%);
    box-shadow: 0px 4px 5px 2px rgba(242, 211, 86, 0.3);
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .page_zhifu1 {
    width: 176px;
    height: 46px;
    background:#FD8C00;
    box-shadow:0 5px 7px 2px rgba(253, 140, 0, 0.3);
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input {
    border: none;
    font-size: 14px;
  }

  ::-webkit-input-placeholder {
    text-align: center;
    color: #BBBBBB;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xianxia/packageDesc.vue